/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  const ingredientListHandler = {
    modal: document.getElementById("ingredientModal"),
    modalBtn: document.getElementById("ingredientModalBtn"),
    closeBtn: document.getElementById("ingredient-list__close"),
    init() {
      if (this.modal) {
        // const closeElements = [this.modal, this.closeBtn];
        const closeElements = [
          this.closeBtn,
          this.modal.querySelector(".ingredient-list__overlay"),
        ];

        this.modalBtn.onclick = () => {
          this.modal.style.display = "flex";
          document.body.style.overflow = "hidden";
        };

        closeElements.forEach((element) => {
          if (element) {
            element.onclick = (event) => {
              this.modal.style.display = "none";
              document.body.style.overflow = "";
            };
          }
        });
      }
    },
  };

  const swiperHandler = {
    init_product() {
      const swiperProducts = new Swiper(".swiper-product-gallery", {
        loop: true,
        speed: 600,
        effect: "fade",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    init_scent() {
      const swiperScentThumbs = new Swiper(".scent-thumbs-swiper", {
        loop: true,
        spaceBetween: 15,
        slidesPerView: 3,
        watchSlidesProgress: true,
      });

      const swiperScent = new Swiper(".scent-swiper", {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 800,
        breakpoints: {
          750: {
            slidesPerView: 3,
          },
        },
        thumbs: {
          swiper: swiperScentThumbs,
        },
      });
    },
  };

  const animationHandler = {
    elements: [...document.querySelectorAll(".fait-main--slide")],
    announcementBar: document.querySelector(".page-announcement"),
    header: document.querySelector(".theme__header"),
    init() {
      gsap.registerPlugin(ScrollTrigger);

      if (this.elements.length) {
        this.setElements();
        this.animateHero();
      }
    },
    setElements() {
      gsap.set(this.elements, { opacity: 1 });
    },
    animateHero() {
      const headerHeight =
        (this.announcementBar?.offsetHeight || 0) +
        (this.header?.offsetHeight || 0);

      let tl = gsap.timeline();

      tl.to(this.elements[0], {
        opacity: 0,
        ease: "power2.inOut",
        duration: 1,
        scrollTrigger: {
          trigger: ".fait-main",
          start: `20% ${headerHeight}px`,
          end: "top 95%",
          pin: true,
          scrub: 1.5,
        },
      });
    },
  };

  document.addEventListener("DOMContentLoaded", function () {
    ingredientListHandler.init();
    swiperHandler.init_scent();
    swiperHandler.init_product();
    animationHandler.init();
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
